/**
 * Sprint 11, story-042 (U77). graphql-request wrapper for story-041's slot-fulfillment query —
 * mirrors this codebase's existing three-file query/hook/service shape (e.g. `services/document`).
 */
import { graphQlClient } from '@config/graphqlClient';
import EvidenceSlotGraphQL from '@graphql/evidenceSlot.queries';

export type EvidenceSlotStatus = 'FILLED' | 'EMPTY' | 'FAILED';

/** Sprint 12, story-051 (U72). ASSUMPTION A2 — no card guidance pinned the exact set. */
export type EvidenceSlotDispositionType = 'NOT_APPLICABLE' | 'ACCESS_DENIED' | 'OTHER';

export interface EvidenceCaptureRef {
  documentId: string;
  thumbnailUrl?: string | null;
  capturedAt: string;
  capturedByName?: string | null;
  captureChannel?: string | null;
  deliveryStatus: 'PENDING' | 'COMPLETE' | 'FAILED';
  dispositionType?: EvidenceSlotDispositionType | null;
  dispositionReason?: string | null;
}

export interface EvidenceSlotState {
  slotId: string;
  label: string;
  required: boolean;
  repeatable: boolean;
  status: EvidenceSlotStatus;
  captures: EvidenceCaptureRef[];
}

export interface TaskEvidenceSlotState {
  taskId: string;
  taskName: string;
  slots: EvidenceSlotState[];
}

export const evidenceSlotService = {
  async getForTask(taskId: string): Promise<EvidenceSlotState[]> {
    const data: any = await graphQlClient.request(
      EvidenceSlotGraphQL.queries.getEvidenceSlotStatusForTask,
      { taskId },
    );
    return data.getEvidenceSlotStatusForTask;
  },

  async getForProject(projectId: string): Promise<EvidenceSlotState[]> {
    const data: any = await graphQlClient.request(
      EvidenceSlotGraphQL.queries.getEvidenceSlotStatusForProject,
      { projectId },
    );
    return data.getEvidenceSlotStatusForProject;
  },

  async getByProject(projectId: string): Promise<TaskEvidenceSlotState[]> {
    const data: any = await graphQlClient.request(
      EvidenceSlotGraphQL.queries.getEvidenceSlotStatusByProject,
      { projectId },
    );
    return data.getEvidenceSlotStatusByProject;
  },
};

export default evidenceSlotService;
